import styles from './NavMenu.module.scss';
import React, { ReactNode, useEffect, useState } from 'react';
import classnames from 'classnames';

export interface NavMenuProps {
  className?: string;
  name: string;
  openMenu: (menuName: string) => void;
  closeMenu: () => void;
  activeMenu: string;
  children: ReactNode;
}

export const NavMenu = ({
  className,
  name,
  openMenu,
  closeMenu,
  activeMenu,
  children,
}: NavMenuProps) => {
  // the enabled state prevents the menu from displaying the initial .closed animation
  // once the menu has been displayed, the menu becomes enabled
  const [enabled, setEnabled] = useState<boolean>(false);
  useEffect(() => {
    if (activeMenu === name) {
      setEnabled(true);
    }
  }, [activeMenu, name]);

  return (
    <div
      onMouseEnter={() => openMenu(name)}
      onMouseLeave={() => closeMenu()}
      className={classnames(
        styles.menuContainer,
        enabled ? (activeMenu === name ? styles.open : styles.closed) : styles.hidden,
        className
      )}>
      {children}
    </div>
  );
};
